// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__4T6S2","footer":"ModalCreateQualiphyProcedure_footer__3V1cP","additionData":"ModalCreateQualiphyProcedure_additionData__1o47N"};